import { Autocomplete, AutocompleteItem } from '@nextui-org/react';
import React, { useState } from 'react';

function DropdownWithSearch({
  data,
  placeholder,
  SelectItem,
  isInvalid,
  error,
  before,
}) {
  const [value, setValue] = useState(
    typeof before === 'string' ? before : String(before)
  );

  const handleChange = (value) => {
    setValue(value);
    SelectItem(value);
  };

  return (
    <div className="flex w-full flex-wrap md:flex-nowrap gap-4">
      <Autocomplete
        size="sm"
        labelPlacement="outside"
        label={placeholder}
        placeholder={placeholder}
        className="max-w-xs"
        defaultItems={data}
        scrollShadowProps={{
          isEnabled: false,
        }}
        selectedKey={value}
        onSelectionChange={handleChange}
        errorMessage={error}
        isInvalid={isInvalid}
      >
        {data?.map((item) => (
          <AutocompleteItem key={item.value} value={item.label}>
            {item.label}
          </AutocompleteItem>
        ))}
      </Autocomplete>
    </div>
  );
}

export default DropdownWithSearch;
